/**
 * @flow
 * @author: Chinmaya
 */

import styled from 'react-emotion'
import {
  Typo18whiteTwoDBI,
  Typo14whiteTwoDBI
} from '../../themes/Fonts/Din2014'
import { minDeviceWidth } from '../../utils/mixins'

export const NewsSectionContainer = styled('section')`
  font-size: 16px;
  @media (min-width: 320px) and (max-width: 375px) {
    font-size: 0.875rem;
  }
  @media (min-width: 600px) and (max-width: 674px) {
    font-size: 0.8125rem;
  }
  @media (min-width: 675px) and (max-width: 675px) {
    font-size: 0.9375rem;
  }
  @media (min-width: 768px) and (max-width: 949px) {
    font-size: 1rem;
  }
  @media (min-width: 950px) and (max-width: 1199px) {
    font-size: 0.875rem;
  }
`

export const NewsCardHolder = styled(NewsSectionContainer)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  padding-top: 3.75em;
  padding-bottom: 3.75em;
  @media (max-width: 599px) {
    align-items: center;
    flex-direction: column;
    padding-top: 2.5em;
    padding-bottom: 2.5em;
  }
  @media (max-width: 767px) {
    justify-content: space-around;
  }
`

export const NewsPageResponsiveHolder = styled('div')`
  margin: auto;
  @media (max-width: 767px) {
    width: 94%;
    margin: auto;
  }
  @media (min-width: 768px) {
    width: 700px;
  }
  @media (min-width: 950px) {
    width: 900px;
  }
  @media (min-width: 1200px) {
    width: 1056px;
  }
`
export const NewsPageHeading = styled(Typo18whiteTwoDBI)`
  letter-spacing: 0.3px;
  line-height: normal;
  text-align: left;
  @media (min-width: 320px) and (max-width: 767px) {
    font-size: 1.143em;
    margin-bottom: 0.375em;
    overflow: hidden;
    height: 2.875em;
  }
`
const bgImg =
  'https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/News/startup-of-the-year-vr-desktop.png'
const mblImg =
  'https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/News/Startup+of+the+Year_Mobile_v2.jpg'
export const NewsPageHeadingHolder = styled('div')`
  padding-top: 22.513em;
  position: relative;
  padding-bottom: 2.313em;
  background: url('${bgImg}'), rgba(18, 18, 18, 0.5);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 400px;
  @media (max-width: 500px) {
    padding-top: 8.513em;
    background-image: url(${mblImg});
    height: 16.5625em;
    padding-bottom: 1.429em;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: transparent;
    background-position-y: 120%;
  }
  @media (min-width: 500px) and (max-width: 767px) {
    padding-top: 8.513em;
    background-image: url(${mblImg});
    height: 19.5625em;
    padding-bottom: 1.429em;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: transparent;
    background-position-y: 110%;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    padding-top: 8.513em;
    background-image: url(${mblImg});
    height: 30.5625em;
    padding-bottom: 1.429em;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: transparent;
    background-position-y: 105%;
  }
  ${minDeviceWidth(1500)} {
    height: 545px;
  }
`

export const NewsSubPageHeading = styled(Typo14whiteTwoDBI)`
  text-align: left;
  padding-top: 4px;
  line-height: normal;
  letter-spacing: normal;
`
export const NewsSubPageHeading2 = styled('a')`
  width: 50%;
  font-family: din-2014;
  font-size: 0.938em;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.53;
  letter-spacing: normal;
  text-align: right;
  color: #ffffff;
  &:hover {
    text-decoration: none;
    outline: none;
    color: #ffffff;
  }
  &:focus {
    text-decoration: none;
    outline: none;
    color: #ffffff;
  }
  &:active {
    text-decoration: none;
    outline: none;
    color: #ffffff;
  }
`
export const NewsSubHeadingHolder = styled('div')`
  width: 100%;
  display: flex;
`
export const NewsPageHolder = styled('section')`
  font-size: 1em;
`



// WEBPACK FOOTER //
// ./src/components/IbcNews/styledComponents.js